import "./OptimizelyEditProperty.scss";
import cn from "classnames";
import { ReactNode } from "react";

interface Props {
  propertyName?: string;
  children: ReactNode | ReactNode[] | undefined;
  clientRender?: boolean;
  useAvailableHeight?: boolean;
}

const OptimizelyEditProperty: React.FC<Props> = ({
  propertyName,
  children,
  clientRender,
  useAvailableHeight,
}) => {
  if (!children && !propertyName) {
    return null;
  }

  if (!propertyName) {
    return <>{children}</>;
  }

  return (
    <div
      className={cn({
        "epi-editContainer": propertyName,
        "optimizely-edit-property-norad__use-available-height":
          useAvailableHeight,
      })}
      data-epi-property-name={propertyName}
      data-epi-property-render={propertyName && clientRender ? "client" : null}
    >
      {children}
    </div>
  );
};

export default OptimizelyEditProperty;
